import { Button, Group, Modal, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import React, { cloneElement, useState } from "react";

const ConfirmDialog: React.FC<{
  title: string;
  message: string;
  confirmCb: () => void;
  children: JSX.Element;
  color?: string;
  confirmButtonText?: string;
}> = ({ title, message, confirmCb, children, confirmButtonText, color }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const confirmClick = () => {
    setIsOpen(false);
    confirmCb();
  };
  return (
    <>
      <>{cloneElement(children, { onClick: () => setIsOpen(true) })}</>
      <Modal
        opened={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        yOffset={140}
        zIndex={4000}
        overlayProps={{ zIndex: 3990 }}
      >
        <Text mb="lg" fz={"1em"}>
          {message}
        </Text>
        <Group justify="flex-end">
          <Button variant="outline" color="warmgray.7" onClick={() => setIsOpen(false)}>
            Avbryt
          </Button>
          <Button
            leftSection={<IconAlertTriangle size="1rem" />}
            color={color != null ? color : "red"}
            variant="danger-filled"
            onClick={confirmClick}
          >
            {confirmButtonText != null ? confirmButtonText : "Slett"}
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default ConfirmDialog;
